import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
// import Loader from "../../../common/loader";
import CustomCkeditor from "../../../common/customeditor";
import * as pageServices from "../../../services/pages.services";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_50, MENU_LOCATION, showFilterList } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const PageEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation()  

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_pages"), url: "/admin/cms/pages/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    pageServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data?.data ? data.data : []);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (<Formik
        enableReinitialize
        initialValues={{
          title: showdefault && showdefault.title ? showdefault.title : "",
          slug: showdefault && showdefault.slug ? showdefault.slug : "",
          status:
            showdefault && showdefault.status,
          showInHeader: showdefault && showdefault.showInHeader ? showdefault.showInHeader : false,
          short_description: showdefault && showdefault.shortDescription ? showdefault.shortDescription : "",
          richtext:
            showdefault && showdefault.description
              ? showdefault.description
              : "",
          imagePreview: showdefault && showdefault.image ? showdefault.image : "",
          imagesPreview: showdefault && showdefault.images ? showdefault.images : [],
          imagesToRemove: [],
        }}
        validate={(values) => {
          const error = {};

          // Trim all necessary string fields first
          const title = values.title?.trim() || "";
          const slug = values.slug?.trim() || "";
          const short_description = values.short_description?.trim() || "";
          // const status = values.status?.trim() || "";
          const richtext = values.richtext;

          // Title Validation
          if (!title) error.title = t("label_title_error");
          else if (title.length > INPUT_LENGTH_50)
            error.title = t("validation_err_reached_maximum_length");

          // Slug Validation
          if (!slug) error.slug = t("label_slug_error");
          else if (slug.length > INPUT_LENGTH_50)
            error.slug = t("validation_err_reached_maximum_length");

          // Status Validation
          if (!values.status) error.status = t("validation_err_status_required");

          // Menu Location Validation
          // if (!values.menu_location) error.menu_location = t("validation_err_menu_location");

          // Short Description Validation
          if (!short_description) error.short_description = t("label_short_description_error");

          // Rich Text Validation
          if (!richtext) error.richtext = t("label_long_description_error");

          return error;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          globalLoader(true);
          const id = params.id;
          let formData = new FormData();
          // formData.append("o_id", params.id);
          formData.append("title", values.title);
          formData.append("slug", values.slug);
          formData.append("status", values.status);
          formData.append("showInHeader", values.showInHeader);
          formData.append("shortDescription", values.short_description);
          formData.append("description", values.richtext);
          if (values.image) {
            formData.append("image", values.image);
          }
          if (values.images && values.images.length > 0) {
            values.images.forEach((file) => {
              if (file instanceof File) {
                formData.append("images", file);
              }
            });
          }
          if (values.imagesToRemove && values.imagesToRemove.length > 0) {
            values.imagesToRemove.forEach((url) => {
              formData.append("imagesToRemove", url);
            });
          }

          pageServices
            .Edit(formData, id)
            .then((response) => {
              setSubmitting(false);
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                if (saveType !== "Save") {
                  setTimeout(() => {
                    resetForm({ values: "" });
                    globalLoader(false);
                    navigate(`/admin/cms/pages/list/1`);
                  }, 1000);
                }
                if (saveType === "Save") {
                  setTimeout(() => {
                    globalLoader(false);
                  }, 1000);
                }
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
                globalLoader(false);
              }
            })
            .catch((error) => {
              console.log("error ====> ", error);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              <div className="col-lg-12 col-md-12 animation_fade">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="main-content-label mb-3">{t("edit_cms")}</h6>
                    </div>
                    {showdefault && Object.keys(showdefault).length > 0 ? (
                      <div className="row row-sm">

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("label_page_titles")}:<span className="requirestar">*</span>
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("tooltip_page_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                         
                          <input
                            name="title"
                            id="title"
                            type="text"
                            placeholder="Enter the title"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title && touched.title && errors.title}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="slug" className="text-left d-flex">
                            {t("label_slug_of_page")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="slug"
                            id="slug"
                            type="text"
                            placeholder="Enter the slug"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.slug}
                            disabled={"disabled"}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.slug && touched.slug && errors.slug}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            {t("list_heading_status")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="status"
                              id="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                              className="form-control" >

                              {(showFilterList).map((value, i) => {
                                return (
                                  <option key={i} value={value.status__id}>{t(`${value.name}`)}</option>
                                )
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.status &&
                              touched.status &&
                              errors.status}
                          </span>
                        </div>
                        <div className="col-md-12 text-left form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              name="showInHeader"
                              id="showInHeader"
                              checked={values.showInHeader}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="form-check-input"
                              style={{ position: 'relative', marginTop: 0, marginLeft: 0, width: '20px', height: '20px', cursor: 'pointer', marginRight: '10px' }}
                            />
                            <label htmlFor="showInHeader" className="mb-0" style={{ cursor: 'pointer', fontSize: '15px' }}>
                              Show in Header:
                            </label>
                          </div>
                          <div className="mt-1" style={{ marginLeft: '30px' }}>
                            <span className="text-muted">Enable this to display the page tab in the website header</span>
                          </div>
                        </div>

                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_tags"
                            className="text-left d-flex"
                          >
                             {t("meta_tags")}:{" "}
                          </label>
                          <textarea
                            name="meta_tags"
                            id="meta_tags"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_tags}
                            className="form-control"
                          />
                        </div> */}
                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_keyword"
                            className="text-left d-flex"
                          >
                             {t("meta_keywords")}:{" "}
                          </label>
                          <textarea
                            name="meta_keyword"
                            id="meta_keyword"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_keyword}
                            className="form-control"
                          />
                        </div> */}
                        <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="short_description"
                            className="text-left d-flex"
                          >
                            {t("label_short_descriptions")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="short_description"
                            id="short_description"
                            rows="2"
                            type="text"
                            placeholder="Enter the short description"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.short_description}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.short_description &&
                              touched.short_description &&
                              errors.short_description}
                          </span>
                        </div>
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="image" className="text-left d-flex">
                            {t("label_page_image")}:
                          </label>
                          <div className="d-flex align-items-center">
                            <input
                              name="image"
                              id="image"
                              type="file"
                              accept="image/*"
                              className="form-control"
                              onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                setFieldValue("image", file);
                                if (file) {
                                  setFieldValue("imagePreview", URL.createObjectURL(file));
                                }
                              }}
                            />
                          </div>
                          {values.imagePreview && (
                            <div className="mt-2 text-left">
                              <img
                                src={values.imagePreview}
                                alt="Preview"
                                style={{ maxWidth: "200px", borderRadius: "8px" }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="images" className="text-left d-flex">
                            Multiple Images (e.g. for Features):
                          </label>
                          <div className="d-flex align-items-center">
                            <input
                              name="images"
                              id="images"
                              type="file"
                              multiple
                              accept="image/*"
                              className="form-control"
                              onChange={(event) => {
                                const files = Array.from(event.currentTarget.files);
                                setFieldValue("images", files);
                                if (files.length > 0) {
                                  const previews = files.map(file => URL.createObjectURL(file));
                                  setFieldValue("imagesPreview", previews);
                                }
                              }}
                            />
                          </div>
                          {values.imagesPreview && values.imagesPreview.length > 0 && (
                            <div className="mt-2 d-flex flex-wrap gap-2 text-left">
                              {values.imagesPreview.map((src, index) => (
                                <div key={index} className="position-relative">
                                  <img
                                    src={src}
                                    alt={`Preview ${index}`}
                                    style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }}
                                  />
                                  <span
                                    className="position-absolute cp"
                                    style={{ 
                                      top: "-8px", 
                                      right: "-8px", 
                                      backgroundColor: "red", 
                                      color: "white", 
                                      borderRadius: "50%", 
                                      width: "20px", 
                                      height: "20px", 
                                      display: "flex", 
                                      alignItems: "center", 
                                      justifyContent: "center",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      zIndex: 10
                                    }}
                                    onClick={() => {
                                      const updatedPreviews = [...values.imagesPreview];
                                      const removedImg = updatedPreviews.splice(index, 1)[0];
                                      setFieldValue("imagesPreview", updatedPreviews);

                                      // If it was an existing image (URL), add to imagesToRemove
                                      if (typeof removedImg === "string" && !removedImg.startsWith("blob:")) {
                                        const currentToRemove = values.imagesToRemove || [];
                                        setFieldValue("imagesToRemove", [...currentToRemove, removedImg]);
                                      } else {
                                        // If it was a newly selected file, remove from images array
                                        const updatedFiles = [...(values.images || [])];
                                        // We need to find the file that matches this preview
                                        // Since previews were created from files in order, we can use the same index
                                        // BUT we must adjust the index because some might be existing URLs
                                        const existingImagesCount = values.imagesPreview.filter(p => typeof p === "string" && !p.startsWith("blob:")).length;
                                        const fileIndex = index - existingImagesCount;
                                        if (fileIndex >= 0) {
                                           updatedFiles.splice(fileIndex, 1);
                                           setFieldValue("images", updatedFiles);
                                        }
                                      }
                                    }}
                                  >
                                    &times;
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="subject" className="text-left d-flex">
                            {t("label_long_descriptions")}:<span className="requirestar">*</span>
                          </label>
                          {dataLoaded ? (
                            <CustomCkeditor
                              fieldname={"richtext"}
                              setFieldValue={setFieldValue}
                              value={values.richtext}
                              setFieldTouched={setFieldTouched}
                            />
                          ) : ""}

                          <span className="text-danger d-flex text-left">
                            {errors.richtext &&
                              touched.richtext &&
                              errors.richtext}
                          </span>
                        </div>


                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
      ) : (
        <Loader />
      )}

    </>
  );
};

export default PageEdit;
